import { Box } from '@mui/material';
import React from 'react';

const mainStyles = { flexGrow: 1 };

const Main = ({ children }) => <Box mb={6} sx={mainStyles}>{children}</Box>;

export { Main };
